import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { TalkJsContext, UserDetailsContextInterface } from "../../contexts";
import { TalkJsContextInterface, UserDetailsContext } from "../../contexts";
import { TracksPageLeftSideDrawerProps } from "./types";
import { DcContainer } from "./styles";
import Messages from "../Messages/Messages";
import { GetEnterpriseAllUsersResponse, User } from "../../proto/api_pb";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { getEnterpriseAllUsers } from "../../services/enterpriseService";
import { DrawerPages } from "../Drawer/DrawerPages";
import { DrawerLogos } from "../Drawer/DrawerLogos";
import { DrawerStorage } from "../Drawer/DrawerStorage";
import { DrawerProfileDetails } from "../Drawer/DrawerProfileDetails";
import { DrawerSocialMediaLinks } from "../Drawer/DrawerSocialMediaLinks";
import { useParams } from "react-router-dom";

export const Drawer: React.FC<TracksPageLeftSideDrawerProps> = ({
  currentUser,
  isDrawerOpen,
  setIsDrawerOpen,
  isChatLoading,
  session,
  setInbox,
  setParticipants,
  createConversation,
  autoCreateChat,
}) => {
  const [currentPage, setCurrentPage] = useState("Tracks");
  const [userNames, setUserNames] = useState<User[]>([]);
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const { id } = useParams();
  const { allUsers, isEnterpriseAccount, enterprise } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const { getValidAccessToken } = useGetValidAccessToken();

  useEffect(() => {
    const handleUserNames = async () => {
      const token = await getValidAccessToken();
      const res = await getEnterpriseAllUsers(token, enterprise?.id ?? "");
      if (res instanceof GetEnterpriseAllUsersResponse) {
        const uName = res
          .getUsersList()
          .filter((user) => !user.getUsername()?.includes("dummy_ommuse"));
        setUserNames(uName);
      }
    };
    handleUserNames();
  }, [enterprise?.id, getValidAccessToken]);

  useEffect(() => {
    if (window.location.href.includes("explore")) {
      setCurrentPage("Explore");
    } else if (window.location.href.includes("my-tracks")) {
      setCurrentPage("Hub");
    } else if (
      window.location.href.includes("projects") &&
      id !== "undefined"
    ) {
      setCurrentPage("Projects");
    }
  }, [id]);

  return (
    <>
      <DcContainer>
        <Box>
          <DrawerLogos
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
          <DrawerPages
            currentUser={currentUser}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            session={session}
            setInbox={setInbox}
          />
          <Box sx={{ position: "relative" }}>
            {talkJsContext.isChatOpen && (
              <Messages
                autoCompleteOptions={isEnterpriseAccount ? userNames : allUsers}
                isChatLoading={isChatLoading!}
                session={session}
                setInbox={setInbox!}
                setParticipants={setParticipants!}
                createConversation={createConversation!}
                autoCreateChat={autoCreateChat!}
              />
            )}
          </Box>
        </Box>
        {!talkJsContext.isChatOpen && (
          <Box>
            <DrawerStorage currentUser={currentUser} />
            <DrawerProfileDetails currentUser={currentUser} />
            <DrawerSocialMediaLinks />
          </Box>
        )}
      </DcContainer>
    </>
  );
};
